import axios from "axios";
import API from "../helpers/api";
import { getShipnameList } from "./HelpersAPI";

let user = JSON.parse(localStorage.getItem("currentUser"));

export const searchCrewMgmt = (searchItem,pgno) => {
    let url = `${API.SearchCrews}?CrewId=${searchItem.crewId}&mail=${user.email}&Name=${searchItem.name}&shipId=${searchItem.shipId??0}&ClientId=${searchItem.clientId}&FromDate=${searchItem.fromDate}&ToDate=${searchItem.toDate}&Designation=${searchItem.designation}&PageNumber=${pgno}&PageSize=${searchItem.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchCrewSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getSearchCrewFailure",
                    error: "ERROR"
                })
            })
    }
}
  
export const getCrewDetails = (crewId) => {
    let url = `${API.GetCrewDetails}?CrewMemberId=${crewId}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getCrewDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getCrewDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}

export const addCrewMember = (data) => {
    let url = `${API.PostCrew}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                dispatch({
                    type: "postAddCrewSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postAddCrewFailure",
                    error: "ERROR"
                })
            })
    }
}

export const updateCrewMember = (data) => {
    let url = `${API.UpdateCrew}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                dispatch({
                    type: "putUpdateCrewSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putUpdateCrewFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getPhoto = (id) => {
    let url = `${API.Photo}?CrewMemberId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getPhotoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getPhotoFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getCrewPhoto = (id) => {
    let url = `${API.CrewPhoto}?reportId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getCrewPhotoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getCrewPhotoFailure",
                    error: "ERROR"
                })
            })
    }
}

export const searchCrewMgmtDidmount = (searchItem,pgno) => {
    let url = `${API.SearchCrews}?CrewId=${searchItem.crewId}&mail=${user.email}&Name=${searchItem.name}&shipId=${searchItem.shipId??0}&ClientId=${searchItem.clientId}&FromDate=${searchItem.fromDate}&ToDate=${searchItem.toDate}&Designation=${searchItem.designation}&PageNumber=${pgno}&PageSize=${searchItem.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchCrewSuccess",
                    data: response.data,
                });
                dispatch(getShipnameList());
            })
            .catch((error) => {
                dispatch({
                    type: "getSearchCrewFailure",
                    error: "ERROR"
                })
            })
    }
}